import * as jQuery from 'jquery';

export class Modal {

	public static resize() {
		let modalBodyHeight: number;

		if (jQuery('.bk-modal__scroll-area:visible').hasClass('bk-modal__events-container')) {
			modalBodyHeight = jQuery(window).height() - 400;
		} else {
			modalBodyHeight = jQuery(window).height() - 200;
		}
		if (modalBodyHeight > 0) {
			if (jQuery('.bk-modal__scroll-area:visible').hasClass('bk-modal__events-container')) {
				jQuery('.bk-modal__scroll-area').css('height', modalBodyHeight).css('max-height', '');
			} else {
				// jQuery(".bk-modal__scroll-area").css("max-height", modalBodyHeight).css("height", "");
				// removed this - controlling height and max height using calc() in CSS - the code is not
				// reliable in mobile
			}
		}
	}

	public static eventsResize() {
		let heights: {
			eventsHeader: number,
			eventsFooter: number,
			modalBody: number
		} = {
			eventsHeader: null,
			eventsFooter: null,
			modalBody: null
		};

		if (jQuery('.bk-modal__scroll-area:visible').hasClass('bk-modal__events-container')) {
			heights.eventsHeader = jQuery('.bk-modal__events-header--container').outerHeight();
			heights.eventsFooter = jQuery('.bk-modal__events-footer--container').outerHeight();

			if (jQuery('.bk-modal__events-footer--container').is(':visible')) {
				heights.modalBody = jQuery('.bk-modal_events-content').height() - (heights.eventsHeader + heights.eventsFooter);
			} else {
				heights.modalBody = jQuery('.bk-modal_events-content').height() - heights.eventsHeader;
			}
		}

		if (heights.modalBody && heights.modalBody > 0) {
			if (jQuery('.bk-modal__events-body--container').height() === heights.modalBody) {
				return;
			}
			jQuery('.bk-modal__events-body--container').css('height', heights.modalBody).css('max-height', '');
		}
	}

	public static resetVerticalPosition() {
		jQuery('.bk-modal__scroll-area').scrollTop(0);
	}
}
